import { DateTime } from 'luxon';

export const fromFormat = (text, format = 'd/M/yyyy') => DateTime.fromFormat(text, format);
export const isValid = date => date.isValid;
export const isValidFromString = (dateString, format) => isValid(fromFormat(dateString, format));
